import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NavBar, ListView, Card, WingBlank, WhiteSpace, Picker, List, Badge, Toast, ActionSheet } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import DataFetcher from '../utils/DataFetcher';
import { createForm } from 'rc-form';
import '../styles/OperatorCoupon.css';
import Constants from '../utils/Constants';
import CommonUtils from '../utils/CommonUtils';

const history = require("history").createHashHistory()

class OperatorCoupon extends Component {
    constructor(props) {
        super(props);

        let dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 3 / 4,
            organizations: null,
            selectedItem: null,
            selectedOrganization: null,
            deviceTypes: []
        };
    }

    componentDidMount() {
        let height = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop - 135;
        this.setState({
            height
        })
        this.loadDeviceTypes()
        this.loadOrganizations(() => {
            this.loadPageData(1)
        })
    }

    loadDeviceTypes = () => {
        DataFetcher.deviceTypes({}, {
            success: (resp) => {
                this.setState({
                    deviceTypes: resp.data
                })
            }
        })
    }

    loadOrganizations = (callback) => {
        DataFetcher.operatorOrganizations({
        }, {
            success: (resp) => {
                this.setState({
                    organizations: resp.data ? resp.data : [],
                    selectedOrganization: resp.data&&resp.data[0] ? resp.data[0].id : null
                }, () => {
                    callback&&callback()
                })
            }
        })
    }

    loadPageData = (pageNum) => {
        const { selectedOrganization } = this.state
        if(!selectedOrganization) {
            this.setState({
                isLoading: false
            })
            return
        }

        DataFetcher.operatorActivities({
            pageNum,
            pageSize: 10,
            organizationId: selectedOrganization
        }, {
            success: (resp) => {
                let data = resp.data
                this.pageNum = data.pageNum;
                this.pageSize = data.pageSize;
                this.pages = data.pages;
                let oldRowDatas = this.rowDatas&&pageNum>1 ? this.rowDatas : {}
                this.rowDatas = {...oldRowDatas, ...this.wrapIntoRowDatas(data.result)};
                this.setState({
                    dataSource: this.state.dataSource.cloneWithRows(this.rowDatas),
                    isLoading: false,
                    hasMore: this.pageNum < this.pages,
                })
            }
        })
    }

    handleItemClick = (rowData) => {
        const { selectedOrganization } = this.state

        const options = [
            { icon: <i className='iconfont icon-group-chat' style={{color:'#04bbc5', fontSize: 30}}/>, title: '领券记录' },
            { icon: <i className='iconfont icon-erweima' style={{color:'orange', fontSize: 35}}/>, title: '动态券码' }
        ]
        
        let optionMap = {}
        for(let i = 0; i < options.length; i++) {
            optionMap[i] = options[i].title
        }
        ActionSheet.showShareActionSheetWithOptions({
            options,
            title: '操作',
            message: rowData.name,
        },
        (buttonIndex) => {
            let buttonTitle = optionMap[buttonIndex]
            if(!buttonTitle) return

            if(buttonTitle === '领券记录') {
                history.push(`/operator/coupon_grabbed?activityId=${rowData.id}`)
            } else if(buttonTitle === '动态券码') {
                history.push(`/operator/coupon_ticket?activityId=${rowData.id}&organizationId=${selectedOrganization}`)
            } else {
                Toast.info('功能开发中')
            }
        });
    }

    onEndReached = (event) => {
        const { isLoading, hasMore } = this.state

        if (isLoading || !hasMore) {
            return;
        }

        this.setState({ isLoading: true });
        this.loadPageData(++this.pageNum)
    }

    onOrganizationPickerChange = (val) => {
        this.setState({
            selectedOrganization: val[0]
        }, () => {
            this.loadPageData(1)
        })
    }

    wrapIntoRowDatas(datas) {
        if (!datas||datas.length<=0) {
            return {};
        }

        let rowDatas = {};
        datas.forEach((data, index) => {
            let id = this.pageNum*this.pageSize + index
            rowDatas[id] = data;
        })
        return rowDatas;
    }

    renderFooter = (isLoading) => {
        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        const { dataSource } = this.state
        if(dataSource.getRowCount()) {
            return <div></div>
        }

        return <TipPlaceholder firstTip='暂无数据'/>
    }

    renderSeparator(sectionId, rowId) {
        return <WhiteSpace key={rowId}/>
    }

    generateInfoColumnForCouponType = (rowData) => {
        let couponType = rowData.couponType
        if(couponType === 'GAME_MINUTES') {
            return (
                <div className='info-column word-ellipsis'>
                    <span className='label'>游戏时间：</span> 
                    <span className='value'>{rowData.gameMinutes}分钟</span>
                </div>
            )
        } else if(couponType === 'PACKET_DISCOUNT') {
            return (
                <div className='info-column word-ellipsis'>
                    <span className='label'>套餐折扣：</span> 
                    <span className='value'>{rowData.discount}%</span>
                </div>
            )
        }
    }

    renderRow = (rowData, sectionId, rowId) => {
        let progressText = Constants.DICT_ACTIVITY_PROGRESS[rowData.progress]
        let progressColor = rowData.progress==='ONGOING' ? '#04bbc5' : 'gray'
        let progressBadge = (<Badge text={progressText} style={{backgroundColor: progressColor}}/>)
        return (
            <WingBlank size='sm'>
                <div onClick={() => {this.handleItemClick(rowData)}}>
                    <Card key={rowId}>
                        <Card.Header
                            title={<span className='word-ellipsis'>{rowData.name}</span>}
                            extra={progressBadge}
                        />
                        <Card.Body>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>已领券数：</span> 
                                    <span className='value'>{rowData.exchangedCount+rowData.toExchangeCount+rowData.exchangedCount}/{rowData.exchangedCount+rowData.toExchangeCount+rowData.exchangedCount+rowData.initCount}</span>
                                </div>
                                {this.generateInfoColumnForCouponType(rowData)}
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>用户限领：</span> 
                                    <span className='value'>{rowData.limitPerUser?rowData.limitPerUser:'不限'}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>优惠类型：</span> 
                                    <span className='value'>{Constants.DICT_COUPON_TYPE[rowData.couponType]}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column' style={{width: '100%'}}>
                                    <span className='label'>适用门店：</span> 
                                    <span className='value'>{rowData.siteNames&&rowData.siteNames.length?rowData.siteNames.join(','):''}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column' style={{width: '100%'}}>
                                    <span className='label'>活动描述：</span> 
                                    <span className='value'>{rowData.description}</span>
                                </div>
                            </div>
                        </Card.Body>
                        <Card.Footer content={<span>{CommonUtils.resolveDictText(rowData.deviceType, this.state.deviceTypes, 'code', 'name')}</span>} extra={<span className='word-ellipsis'>{CommonUtils.shortenDateTime(rowData.startTime)} ~ {CommonUtils.shortenDateTime(rowData.endTime)}</span>}/>
                    </Card>
                </div>
            </WingBlank>
        )
    }

    doRenderFilterView = () => {
        const { selectedOrganization, organizations } = this.state;
        if(organizations && !organizations.length) {
            return
        }

        let orgPickerOptions = organizations ? organizations.map((item) => {
            return {value: item.id, label: item.name}
        }) : []
        return (
            <div className='wrapper-filter'>
                <WingBlank size='sm'>
                    <Picker 
                        cols={1}
                        value={[selectedOrganization]}
                        onOk={this.onOrganizationPickerChange}
                        data={orgPickerOptions}>
                        <List.Item arrow="horizontal" className='title'>
                            <i className='iconfont icon-guolv'/>
                            <span> 发券商</span>
                        </List.Item>
                    </Picker>
                </WingBlank>
            </div>
        )
    }

    doRenderView = () => {
        const { dataSource, isLoading, organizations } = this.state;

        if(organizations && !organizations.length) {
            return <TipPlaceholder firstTip="无发券商权限"/>
        }

        return (
            <ListView
                ref={el => this.lv = el}
                dataSource={dataSource}
                renderFooter={() => this.renderFooter(isLoading)}
                renderRow={this.renderRow}
                renderSeparator={this.renderSeparator}
                pageSize={8}
                scrollRenderAheadDistance={500}
                onEndReached={this.onEndReached}
                onEndReachedThreshold={10}
                style={{
                    height: this.state.height,
                    overflow: 'auto',
                    paddingTop: 105
                }}
            />
        )
    }

    render() {
        return (
            <div className='page-operator-coupon'>
                <NavBar 
                    mode="light"
                >
                    优惠活动
                </NavBar>
                {this.doRenderFilterView()}
                {this.doRenderView()}
            </div>
        )
    }
}

export default createForm()(OperatorCoupon);


// WEBPACK FOOTER //
// ./src/modules/OperatorCoupon.js